// extracted by mini-css-extract-plugin
export default {"autoContainers":"style_autoContainers__pDaBN","directorsBlock":"style_directorsBlock__GKZ3w","directorsDetail":"style_directorsDetail__r7oqv"};